import { customRuleDataSchema } from "@redotech/redo-inventory-common/cycle-counts";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const previewRow = z.object({
  productId: productIdFormat.schema,
  locationId: locationIdFormat.schema,
  sku: z.string().nullable(),
  productTitle: z.string(),
  locationName: z.string(),
  onHandQuantity: z.number(),
  lastCountedAt: z.date().nullable(),
  unitCost: z.number().nullable(),
  retailPrice: z.number().nullable(),
  included: z.boolean(),
  excluded: z.boolean(),
});

export const previewCycleCountRule = unaryRpc({
  name: "previewCycleCountRule" as const,
  input: z.object({ data: customRuleDataSchema, liveAt: z.date().nullable() }),
  output: z.object({
    includedCount: z.number(),
    excludedCount: z.number(),
    finalCount: z.number(),
    rows: z.array(previewRow),
  }),
});
